import React, { useState } from "react";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import AllowedTo from "../../shared/common/rbac";
import { resubmitFailedSession } from "../../../api/learnosityUtils.service";
import { toast } from "react-toastify";

export const LearnosityResubmit = () => {
  const [base64Text, setBase64Text] = useState<string>();
  const [isInvalidText, setIsInvalidText] = useState<boolean>(false);
  const handleSubmitClick = async () => {
    await resubmitFailedSession({ base64SessionData: base64Text || "" })
      .then((response) => {
        if (response.status === 200 && response.data === true) {
          toast.success("Session submitted successfully");
        } else {
          toast.error("Session submission failed");
        }
      })
      .catch(() => {
        toast.error("Session submission failed with error");
      });
  };

  return (
    <AllowedTo
      perform={Permissions.learnosity_resubmit_view}
      no={() => <AccessDenied />}
    >
      <div className="flex-1">
        <div className="h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7">
          <div className="relative py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                Resubmit Learnosity Failed Session
              </h3>
            </div>
            <AllowedTo perform={Permissions.learnosity_resubmit_modifiy}>
              <div className="pt-6 border-b pb-6">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <label className="text-sm text-gray-700">
                      Data
                      <textarea
                        id={"txt_base64Data"}
                        rows={10}
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        placeholder="Enter base64 session data here"
                        onChange={(e) => {
                          try {
                            if (typeof atob(e.target.value) === "string") {
                              setBase64Text(e.target.value);
                              setIsInvalidText(false);
                            } else {
                              setIsInvalidText(true);
                            }
                          } catch (e) {
                            setIsInvalidText(true);
                          }
                        }}
                      ></textarea>
                    </label>
                  </div>
                  {isInvalidText && (
                    <div className="col-span-12 text-red-500">
                      Invalid base64 text. Please enter valid base64 text.
                    </div>
                  )}
                </div>
                <div className="mt-4">
                  <button
                    onClick={() => handleSubmitClick()}
                    type="submit"
                    className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  >
                    <span>Submit</span>
                  </button>
                </div>
              </div>
            </AllowedTo>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};
